module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/sincerely_2x.6b344d9.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/home/sincerely_2x.png
// module id = gRU9
// module chunks = 41